import React, { useContext } from 'react';
import { SMHeader, StaticContext } from '@sm/webassets';
import AppDirNavHeader from '../AppDirNavHeader';

const ModernHeader = () => {
  const {
    environment: { languageCode: language },
    user,
    locale: { isEUDC },
  } = useContext(StaticContext);

  return (
    <>
      <If condition={user.isAuthenticated}>
        <SMHeader
          lang={language}
          isEUDC={isEUDC}
          user={user}
          isUserAuthenticated={user.isAuthenticated}
          wrenchVariant="apps"
        />
      </If>
      <If condition={!user.isAuthenticated}>
        {/* <Choose>
          <When condition={v2}>
            <NavHeader />
          </When>
          <Otherwise>
          </Otherwise>
        </Choose> */}
        <AppDirNavHeader />
      </If>
    </>
  );
};

export default ModernHeader;
